import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/static/images/markers2/gift.svg")